import { ConfirmedBooking, ManualBlockedDateRow, BookingRequest } from './bookingStorage';
import { expandStayDates } from './stayDates';

export interface OverviewDaySets {
  manual: Set<string>;
  pending: Set<string>;
  confirmed: Set<string>;
}

function appliesToCamp(campId: string | null, filterCampId: string): boolean {
  if (filterCampId === 'all') return true;
  if (campId === null) return true;
  return campId === filterCampId;
}

export function buildOverviewDaySets(
  filterCampId: string,
  manualRows: ManualBlockedDateRow[],
  pendingRequests: BookingRequest[],
  confirmedBookings: ConfirmedBooking[]
): OverviewDaySets {
  const manual = new Set<string>();
  const pending = new Set<string>();
  const confirmed = new Set<string>();

  manualRows.forEach((row) => {
    if (appliesToCamp(row.campId, filterCampId)) {
      manual.add(row.date);
    }
  });

  pendingRequests.forEach((req) => {
    if (req.status !== 'pending') return;
    if (filterCampId !== 'all' && req.campId !== filterCampId) return;
    expandStayDates(req.checkIn, req.checkOut).forEach((d) => pending.add(d));
  });

  confirmedBookings.forEach((booking) => {
    if (booking.status !== 'confirmed') return;
    if (filterCampId !== 'all' && booking.campId !== filterCampId) return;
    expandStayDates(booking.checkIn, booking.checkOut).forEach((d) => confirmed.add(d));
  });

  return { manual, pending, confirmed };
}

export function allOverviewDates(sets: OverviewDaySets): string[] {
  const all = new Set<string>();
  sets.manual.forEach((d) => all.add(d));
  sets.pending.forEach((d) => all.add(d));
  sets.confirmed.forEach((d) => all.add(d));
  return Array.from(all).sort();
}
